customElements.define('component-mobile-menu', class MobileMenu extends HTMLElement {
  static get observedAttributes() {
    return [ 'open' ];
  }

  constructor() {
    super();
    this.SECTION_IMAGE_HERO = 'section_image';
    if (this.dataset.mobileMenuImgSrcset) {
      this.menuImageData = {
        srcset: this.dataset.mobileMenuImgSrcset,
        alt: this.dataset.mobileMenuImgAlt,
        link: this.dataset.mobileMenuImgLink
      }
    }
    this.isSectionOpen = false;
    this.section = undefined;
    this.createdSubmenus = {};
  }

  get open() {
    return this.getAttribute('open');
  }

  set open(value) {
    this.setAttribute('open', value);
    if (value === 'true') {
      this.openMenu();
    } else {
      this.closeMenu();
    }
  }

  connectedCallback() {
    const template = document.getElementById('js-mobile-menu-template');
    this.appendChild(template.content.cloneNode(true));

    // Menu item sections
    this.links = window.theme.menu.main ? window.theme.menu.main : [];
    this.ftrLinks = window.theme.menu.ftr_menu ? window.theme.menu.ftr_menu : [];
    this.footerLinks = window.theme.menu.mobile ? window.theme.menu.mobile : [];
    this.sectionImages = window.theme.menu.sections ? window.theme.menu.sections : {};

    // DOM elements
    this.menuOverlay = this.querySelector('.mobile-menu-overlay');
    this.menu = this.querySelector('.mobile-menu');
    this.menuHeader = this.querySelector('.mobile-menu-header');
    this.menuHeaderTitle = this.querySelector('.mobile-menu-header-title');
    this.menuHeaderBack = this.querySelector('.mobile-menu-header-back');
    this.menuCloseIcon = this.querySelector('.mobile-menu-close-icon');
    this.menuContainer = this.querySelector('.mobile-menu-container');
    this.menuFooter = this.querySelector('.mobile-menu-footer-container');
    this.menuImage = this.querySelector('.mobile-menu-image');

    // Init
    this.menuHeaderBack.addEventListener('click', () => {
      this.closeSection();
    });
    this.menuCloseIcon.addEventListener('click', (e) => {
      this.exitMenu(e, true);
    });
    this.menuOverlay.addEventListener('click', (e) => {
      this.exitMenu(e, false);
    });

    // Render items
    this.renderMenu(this.links);
    this.renderSubmenus(this.createdSubmenus);
    this.renderFooter(this.footerLinks);
    this.renderBottomImage();
    this.renderHookedLogo();

    // Avoid showing mobile menu while loading
    setTimeout(() => {
      this.classList.add("show-menu-after-load");
    }, 3000);
  }

  openMenu() {
    this.menuOverlay.classList.add('open');
    this.menu.classList.add('open');
    document.body.style.overflow = '';
    document.body.classList.add('overflow-hidden');
    document.body.classList.remove('overflow-unset');
  }

  closeMenu() {
    this.closeSection();
    this.menuOverlay.classList.remove('open');
    this.menu.classList.remove('open');
    document.body.classList.remove('overflow-hidden');
    document.body.style.overflow = '';
    document.body.classList.remove('overflow-unset');
  }

  normalizeKey(key) {
    return key.replace(/\W/g, '-').toLowerCase();
  }

  formatTitle(title) {
    return title.replace('&#43;', '+');
  }

  renderMenu(links) {
    if (links && links.length) {
      let allLinks;
      // First create FTR menu item
      allLinks = this.ftrLinks ? this.ftrLinks.concat(links) : links;
      allLinks.forEach((item) => {
        const {title, levels} = item;

        let li;
        if (levels) {
          // is a header section
          li = this.createMenuItemHeader(item);
        } else {
          // is a link
          li = this.createMenuItem(item);
        }
        this.menuContainer.appendChild(li);

        // Create each submenu and store it
        const submenuComponent = document.createElement('component-mobile-menu-submenu');
        submenuComponent.items = item.subItems;
        submenuComponent.sectionImages = this.sectionImages[this.normalizeKey(title)];
        this.createdSubmenus[this.normalizeKey(title)] = submenuComponent;
      });
    }
  }

  createMenuItemHeader(item) {
    const key = this.normalizeKey(item.title);
    const formattedTitle = this.formatTitle(item.title);
    const isKitUnder = item.title.toLowerCase().includes('kit undergarments');

    const li = document.createElement('li');
    li.setAttribute('key', key);
    li.setAttribute('data-attribute', key);

    const a = document.createElement('a');
    a.setAttribute('href', item.url);
    a.classList.add('mobile-menu-link');
    a.addEventListener('click', (event) => this.openSection(item, event));

    if (isKitUnder) {
      const kitIcon = this.renderKitUndergarmentIcon();
      a.insertAdjacentHTML("beforeend", kitIcon);
    } else {
      const span = document.createElement('span');
      span.innerHTML = formattedTitle;
      a.appendChild(span);
    }

    if (item.isFtr) {
      a.classList.add('ftr');
    }

    const spanArrow = document.createElement('span');
    spanArrow.insertAdjacentHTML("beforeend", this.renderArrowRightIcon());
    spanArrow.classList.add('mobile-menu-arrow');

    a.appendChild(spanArrow);
    li.appendChild(a);
    return li;
  }

  createMenuItem(item) {
    // In case the URL doesn't include de domain
    if (!(/^https?:\/\//ig).test(item.url) && item.url != '') {
      this.baseUrlSplit = window.location.host.split('.')
      this.baseUrlSplit.shift();
      this.baseUrl = this.baseUrlSplit.join('.');
      item.url = `https://www.${this.baseUrl}${item.url}`;
    }
    const key = this.normalizeKey(item.title);

    const li = document.createElement('li');
    li.setAttribute('key', key);
    li.setAttribute('data-attribute', key);

    const a = document.createElement('a');
    a.classList.add('mobile-menu-link');
    a.setAttribute('href', item.url);

    if (item.isFtr) {
      a.classList.add('ftr');
    }

    const span = document.createElement('span');
    span.innerHTML = item.title;

    a.appendChild(span);
    li.appendChild(a);
    return li;
  }

  createMenuFooterHeader(item) {
    const li = document.createElement('li');
    li.classList.add('mobile-menu-footer-item');

    const a = document.createElement('a');
    a.classList.add('mobile-menu-footer-link-header');
    a.setAttribute('href', item.url);
    a.innerHTML = item.title;

    li.appendChild(a);
    return li;
  }

  createMenuFooterItem(item, fontWeight) {
    const li = document.createElement('li');
    li.classList.add('mobile-menu-footer-item');

    const a = document.createElement('a');
    a.classList.add('mobile-menu-footer-link');
    a.setAttribute('href', item.url);
    a.innerHTML = item.title;

    if (fontWeight == 'medium') {
      a.classList.add('font-medium');
    }

    li.appendChild(a);
    return li;
  }

  renderSubmenus(submenus) {
    for (let [key, value] of Object.entries(submenus)) {
      value.style.display = 'none';
      value.setAttribute('id', `submenu-${key}`);
      this.menu.insertBefore(value, this.menuFooter);
    }
  }

  renderFooter(links) {
    // First add footer header menu
    const isLoggedIn = this.isLoggedIn();
    const title = isLoggedIn ? 'My Account' : 'Sign in / Sign Up';
    const url = `${window.Shopify.routes.root}${isLoggedIn ? 'account' : 'account/login'}`;

    const liHeader = this.createMenuFooterHeader({title, url});
    this.menuFooter.appendChild(liHeader);

    if (links && links.length) {
      links.forEach((item) => {
        const li = this.createMenuFooterItem(item);
        this.menuFooter.appendChild(li);
      });
    }
  }

  renderBottomImage() {
    let imgSrcset,
    imgAlt,
    imgLink;

    const setFallbackImgData = () => {
      imgSrcset = this.menuImageData.srcset;
      imgAlt = this.menuImageData.alt;
      imgLink = this.menuImageData.link;
    }

    const renderImage = () => {
      if (imgSrcset) this.menuImage.dataset.srcset = imgSrcset;
      if (imgAlt) this.menuImage.alt = imgAlt;
      if (imgLink) this.querySelector('.mobile-menu-image-link').href = imgLink;
      this.menuImage.classList.add('lazyload');
    }

    if (this.menuImageData) {
      setFallbackImgData();
      renderImage();
    } else {
      this.menuImage.remove();
    }
  }

  exitMenu(e, closeIcon) {
    const {target: { className }} = e;
    if (closeIcon ||
        (typeof className === 'string' && className.includes('menu-overlay'))) {
      this.closeMenu();
      this.dispatchEvent(new CustomEvent('mobile-menu-close'));
    }
  };

  openSection(selectedSection, event) {
    event.preventDefault();
    event.stopPropagation();
    this.isSectionOpen = true;
    this.section = selectedSection;
    this.menuContainer.classList.add('open');
    this.menuHeaderTitle.classList.add('open');
    this.menuHeaderBack.classList.add('open');
    this.menuHeader.classList.add('open');
    if (this.section?.title) {
      this.menuHeaderTitle.innerHTML = this.section?.title;
      this.menuHeaderTitle.classList.add(this.section?.title.toLowerCase().split(" ")[0]);
    }
    this.menuImage.classList.add('hidden');
    const key = this.normalizeKey(this.section?.title);
    const submenu = document.querySelector(`#submenu-${key}`);
    submenu.style.display = 'block';
    this.menuFooter.classList.add('hidden');
  }

  closeSection() {
    if (this.section) {
      const key = this.normalizeKey(this.section?.title);
      const submenu = document.querySelector(`#submenu-${key}`);
      submenu.style.display = 'none';
    }
    this.isSectionOpen = false;
    if (this.section?.title) {
      this.menuHeaderTitle.classList.remove(this.section?.title.toLowerCase().split(" ")[0]);
    }
    this.section = undefined;
    this.menuContainer.classList.remove('open');
    this.menuHeaderTitle.classList.remove('open');
    this.menuHeaderBack.classList.remove('open');
    this.menuHeader.classList.remove('open');
    this.menuImage.classList.remove('hidden');
    this.menuHeaderTitle.innerHTML = '';
    this.menuHeader.style.backgroundImage = '';
    this.menuFooter.classList.remove('hidden');
  }

  renderArrowRightIcon() {
    return `<svg width="12" height="12" viewBox="0 0 12 12"fill="none">
        <path d="M0.844727 9L5.48714 5L0.844728 1"
          stroke="#2C272D" strokeWidth="1.5"
          strokeLinecap="round" strokeLinejoin="round"/>
      </svg>`
  }

  renderKitUndergarmentIcon() {
    const icon = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 104.9 14" xml:space="preserve" width="105" height="14" role="img" aria-labelledby="kit-logo"><title id="kit-logo">Kit Undergarments</title><g><g><path d="M9.7,2.1c-0.7,0-1.5,0-2.2,0c0-0.2,0-0.4,0-0.6c0-0.4,0-0.8,0-1.1c0-0.2,0.1-0.2,0.2-0.2c0.6,0,1.2,0,1.8,0
    c0.1,0,0.2,0,0.2,0.2C9.7,0.9,9.7,1.4,9.7,2.1C9.7,2,9.7,2,9.7,2.1z"></path><path d="M2.9,7.9l-0.7,2.2V14H0V0.1h2.2v6.2h0.1l1.9-6.2h2.2L4.5,6.5l2,7.4H4.4L2.9,7.9z"></path><path d="M7.5,2.7h2.2V14H7.5V2.7z"></path><path d="M16.4,2h-1.8v12h-2.2V2h-1.8V0.1h5.7V2L16.4,2z"></path></g><g><path d="M24.6,0.1V11c0,0.6-0.1,1.1-0.3,1.5c-0.2,0.4-0.4,0.7-0.8,1c-0.4,0.3-0.9,0.5-1.5,0.5c-0.7,0-1.2-0.2-1.6-0.5
    c-0.4-0.3-0.6-0.6-0.8-1c-0.2-0.4-0.3-0.9-0.3-1.5V0.1h2V11c0,0.4,0.1,0.6,0.3,0.9c0.1,0.1,0.2,0.1,0.4,0.1c0.4,0,0.5-0.2,0.6-0.5
    c0.1-0.1,0.1-0.3,0.1-0.5V0.1H24.6z"></path><path d="M28,6.8l-0.2-0.6h-0.1v7.8h-1.8V0.1h1.8l2,7.2L29.8,8h0.1V0.1h1.8v13.8H30L28,6.8z"></path><path d="M33.2,13.9V0.1h1.6c1.9,0,2.9,0.4,3.4,1.4c0.5,1.1,0.6,2.8,0.6,5.5s-0.1,4.4-0.6,5.5c-0.5,1.1-1.5,1.4-3.4,1.4L33.2,13.9
    L33.2,13.9z M35.2,11.9c0.7,0,1.1-0.1,1.3-0.8c0.1-0.3,0.2-0.8,0.2-1.5c0-0.7,0-1.5,0-2.7s0-2,0-2.7c0-0.6-0.1-1.1-0.2-1.5
    c-0.2-0.7-0.6-0.7-1.3-0.7V11.9z"></path><path d="M40,0.1h4.3V2H42v4.1h2.3V8H42v4.1h2.3v1.8H40V0.1z"></path><path d="M49.1,13.9l-1-5.9h-0.5v5.9h-2V0.1h2c2.4,0,3.4,1.4,3.4,4c0,1.4-0.4,2.6-1.1,3.1l1.3,6.7H49.1L49.1,13.9z M47.6,6.2
    c0.3,0,0.6,0,0.9-0.3C48.8,5.7,49,5.1,49,4.2s-0.2-1.5-0.5-1.8c-0.3-0.3-0.7-0.3-0.9-0.3V6.2z"></path><path d="M55.4,5.1V3c0-0.4-0.1-0.6-0.3-0.9C55,2,54.9,2,54.7,2c-0.4,0-0.5,0.3-0.6,0.5C54,2.6,54,2.8,54,3v8.2
    c0,0.4,0.1,0.6,0.3,0.9c0.1,0.1,0.2,0.1,0.4,0.1c0.4,0,0.5-0.2,0.6-0.5c0.1-0.1,0.1-0.3,0.1-0.5V8.7h-0.8V7h2.8v6.8h-1.2l-0.2-0.6
    C55.6,13.6,55,14,54.4,14s-1.1-0.2-1.4-0.5c-0.3-0.3-0.6-0.6-0.7-1C52.1,12.1,52,11.6,52,11V3c0-0.5,0.1-1,0.3-1.5
    c0.2-0.4,0.4-0.7,0.8-1C53.5,0.2,54,0,54.7,0s1.2,0.2,1.5,0.5c0.4,0.3,0.6,0.6,0.8,1c0.2,0.4,0.3,0.9,0.3,1.5v2.1L55.4,5.1
    L55.4,5.1L55.4,5.1z"></path><path d="M58.2,13.9l2.1-13.8h2.5l2.1,13.8h-2l-0.4-2.8h-1.9l-0.4,2.8L58.2,13.9L58.2,13.9z M61.6,4.6l-0.1-0.4h-0.1l-0.1,0.4
    L60.8,9h1.4L61.6,4.6z"></path><path d="M69.2,14l-1-5.8h-0.5V14h-2V0.1h2c2.4,0,3.4,1.4,3.4,4c0,1.4-0.4,2.6-1.1,3.1l1.3,6.7L69.2,14L69.2,14z M67.6,6.3
    c0.3,0,0.6,0,0.9-0.3c0.3-0.3,0.5-0.8,0.5-1.7s-0.2-1.5-0.5-1.8s-0.7-0.3-0.9-0.3V6.3z"></path><path d="M75.5,13.9l-1.3-8.7l-0.1-0.6H74v9.2h-1.9V0.1h2.5l1.2,6.3l0.1,0.7h0L76,6.5l1.2-6.3h2.5v13.8h-1.9V4.7h-0.1l-0.1,0.6
    l-1.3,8.7L75.5,13.9L75.5,13.9z"></path><path d="M88.8,6.8l-0.2-0.6h-0.1v7.8h-1.8V0.1h1.8l2,7.2L90.6,8h0.1V0.1h1.8v13.8h-1.8L88.8,6.8z"></path><path d="M93.2,2.2V0.1H99v2.1h-1.9V14h-2V2.2L93.2,2.2L93.2,2.2z"></path><path d="M103,3.8c0-0.4,0-0.9-0.1-1.3c-0.1-0.4-0.3-0.6-0.6-0.6c-0.5,0-0.7,0.6-0.7,1.4c0,0.5,0.2,0.9,0.5,1.5
    c0.3,0.5,0.7,1.1,1.1,1.6c0.5,0.7,0.9,1.4,1.3,2.1s0.6,1.4,0.6,2.1c0,0.9-0.1,1.8-0.6,2.4s-1.1,1-2.2,1c-1.3,0-2-0.5-2.4-1.2
    S99.2,11,99.2,10l2-0.2c0,0.6,0,1.2,0.2,1.6c0.1,0.4,0.4,0.7,0.8,0.7c0.6,0,0.8-0.6,0.8-1.5c0-0.4-0.2-1-0.5-1.5
    c-0.2-0.3-0.3-0.5-0.5-0.8c-0.4-0.6-0.8-1.2-1.3-1.9c-0.4-0.7-0.8-1.4-1-2.1c-0.1-0.4-0.2-0.7-0.2-1.1c0-0.7,0.2-1.5,0.6-2.2
    c0.4-0.6,1.1-1,2-1c1.2,0,1.9,0.5,2.3,1.2c0.4,0.7,0.5,1.7,0.5,2.4L103,3.8z"></path><path d="M81.1,0.1h4.3V2h-2.3v4.1h2.3V8h-2.3v4.1h2.3v1.8h-4.3V0.1z"></path></g></g></svg>`;

    return icon;
  }

  isLoggedIn() {
    const results = jsCookie.get('_tl_customer') || null;
    return !!results;
  }

  renderHookedLogo() {
    const rewardsMenu = document.querySelector('.mobile-menu-container li[data-attribute="rewards"] a');
    const menuContent = rewardsMenu?.innerHTML;
    if (menuContent && !menuContent.includes('mobile-menu-hooked-rewards')) {
      rewardsMenu.innerHTML = `<span class="mobile-menu-hooked-rewards">Hooked®</span> ${menuContent}`;
    }
  }
});



